import styled from 'styled-components';

type Props = {};

export default styled.section<Props>`
  display: flex;
  flex-direction: column;

  .site-page-header {
    background-color: var(--white);
    padding: 4px 32px 4px 40px;
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.2);

    .ant-page-header-heading {
      align-items: center;

      span {
        font-weight: normal;
      }
    }
  }

  .table-content {
    padding-left: 32px;
    padding-right: 32px;

    .ant-table-column-sorter {
      display: flex;

      .anticon {
        font-size: 16px;
      }
    }

    .ant-table-row {
      cursor: pointer;
    }
  }
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00200_現場一覧（未承認） start
  .error-message {
    color: red;
    padding: 0 40px;
    margin-top: 15px;
    margin-bottom: -5px;
  }
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00200_現場一覧（未承認） end
`;
